
import { FlagModel } from '@zajno/common-mobx/viewModels';
import { Disposer, IDisposable } from '@zajno/common/functions/disposer';
import { createLazy } from '@zajno/common/lazy/light';
import { AppController } from 'app/controllers';
import { RouterViewModel } from './components/RouterViewModel';
import { NotificationsViewModel } from './components/NotificationsViewModel';
import { UserRoleViewModel } from './components/UserRoleViewModel';
import { reaction } from 'mobx';
import { LoadMoreViewModel } from './components/LoadMoreViewModel';
import { CampaignData } from 'common/types/models/campaign';


export class AppViewModel implements IDisposable {
    private static readonly _instance = createLazy(() => new AppViewModel());

    public static get Instance() { return AppViewModel._instance.value; }

    public loadMoreCampaignsModel: LoadMoreViewModel<CampaignData> = new LoadMoreViewModel();

    private readonly _disposer = new Disposer();
    private readonly _isLoading = new FlagModel(false);
    public readonly isMenuOpened = new FlagModel(false);
    public readonly notifications = new NotificationsViewModel();
    public readonly userRole = new UserRoleViewModel();

    private readonly _router = new RouterViewModel();

    private constructor() {
        this.initialize();
    }

    get isLoggedIn() { return AppController.Instance.Auth.isLoggedIn; }
    get isLoading() { return this._isLoading.value; }
    get isInitializing() { return AppController.Instance.isInitializing; }
    get router() { return this._router; }

    dispose() {
        this._disposer.dispose();
    }

    private async initialize() {
        await AppController.Instance.initialize();
        AppController.Instance.Users.setObservingEnabled(true);

        this._handleAccountMissing();
    }

    public static Destroy() {
        if (AppViewModel._instance.hasValue) {
            AppViewModel._instance.value.dispose();
            AppViewModel._instance.reset();
        }
    }

    private _handleAccountMissing() {
        reaction(
            () => AppController.Instance.Users?.accountMissing,
            isMissing => {
                if (isMissing === true) {
                    this.notifications.setNotification('Your account is missing. Please try to log in again or contact support.');
                    AppController.Instance.Auth.logOut();
                }
            },
            { fireImmediately: true },
        );
    }
}
